import { getElementChild, getElements } from '../Utility/Dom'

class SearchForm {
    private resetButtons: NodeListOf<HTMLElement>

    constructor() {
      this.resetButtons = getElements('search-form-reset-button')
    }

    public init(): void {
      this.addEvents()
    }

    private addEvents(): void {
      this.resetButtons.forEach((button: HTMLElement): void => {
        button.addEventListener('click', (e): void => {
          e.preventDefault()
          const form = button.closest('form')
          const input = getElementChild(form, 'search-input')

          if (input === null) return

          (input as HTMLInputElement).value = ''
          input.focus()
        })
      })
    }
}

const searchForm = new SearchForm()
searchForm.init()
